import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'ebazzari_cookie_consent'

export default class extends Controller {
  static targets = ['banner']

  connect () {
    // Keep outside transformed ancestors (.site-content-shell) so fixed bottom sticks to viewport.
    if (this.element.parentElement !== document.body) {
      document.body.appendChild(this.element)
    }

    if (this.storedChoice()) {
      this.hide()
    } else {
      this.show()
    }
  }

  accept () {
    this.save('accepted')
    this.hide()
    window.dispatchEvent(new CustomEvent('ebazzari:cookies-accepted'))
  }

  decline () {
    this.save('declined')
    this.hide()
  }

  show () {
    this.element.classList.remove('hidden')
    requestAnimationFrame(() => {
      this.element.classList.remove('translate-y-4', 'opacity-0')
    })
  }

  hide () {
    this.element.classList.add('translate-y-4', 'opacity-0')
    window.setTimeout(() => this.element.classList.add('hidden'), 250)
  }

  storedChoice () {
    try {
      return window.localStorage.getItem(STORAGE_KEY)
    } catch (e) {
      return null
    }
  }

  save (value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value)
    } catch (e) {
      // Ignore storage errors (private mode, etc.)
    }
  }
}
